<template>
  <div class="h-100">
    <div class="loader-cont" v-dxloader="isLoader"></div>
    <div class="row h-100" v-show="!isLoader">
      <div class="content-wrapper-before gradient-45deg-indigo-purple"></div>
      <div class="breadcrumbs-dark pb-0 pt-4" id="breadcrumbs-wrapper">
        <!-- Search for small screen-->
        <div class="container">
          <div class="row">
            <div class="col s10 m6 l6 alignLeft">
              <a class="mr-3 back-icon" @click="$router.push({path: '/app/issue-tickets'})">
                <i class="material-icons">keyboard_backspace</i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="col s12 p-0" style="height:calc(100% - 45px)">
        <div class="container p-0 h-100">
          <div class="section p-0 h-100">
            <div class="row m-0 h-100">
              <div class="col s12 m12 l12 p-0 h-100">
                <div id="responsive-table" class="card card card-default scrollspy p-0 h-100">
                  <div class="card-content h-100" style="overflow:auto">
                    <div class="row">
                      <div class="col s9">
                        <h4 class="card-title alignLeft">#{{issueDetail.issue_no}}</h4>
                        <h4 class="card-title alignLeft">
                          {{issueDetail.title}}
                          <a
                            class="pointer booking"
                            @click="$router.push({path: '/app/booking-detail/' + issueDetail.booking})"
                            v-if="issueDetail.booking"
                          >({{issueDetail.booking}})</a>
                        </h4>
                      </div>
                      <div class="col s3 m3 l3">
                        <div class="assignee-block">
                          <div class="assignee-title">Assignee</div>
                          <div class="assignee" v-if="issueDetail.assigned_to_user">
                            <b>{{issueDetail.assigned_to_user ? issueDetail.assigned_to_user.first_name : ""}} ({{issueDetail.assigned_to_user ? issueDetail.assigned_to_user.short_name : ""}})</b>
                          </div>
                          <div class="assignee" v-if="!issueDetail.assigned_to_user">No one</div>
                          <i
                            @click="openAssignees($event)"
                            class="material-icons a-settings"
                          >settings</i>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col s12">
                        <div class="header-sec">
                          <div class="details">
                            <span
                              v-if="issueDetail.issue_owner"
                              :class="{'p0' : !issueDetail.assigned_to_user}"
                              class="createdby"
                            >
                              Created by
                              <b>{{issueDetail.issue_owner ? issueDetail.issue_owner.first_name : ""}}</b>
                            </span>
                            <span v-if="issueDetail.assigned_to_user" class="divider-line">|</span>
                            <span class="classtag">{{issueDetail.created | date('D MMM YYYY')}}</span>
                          </div>
                          <div class="label-status">
                            <span class="classtag">{{issueDetail.classification}}</span>
                            <span class="prioritytag">{{issueDetail.issue_priority}}</span>
                            <span class="statustag">{{issueDetail.status}}</span>
                          </div>
                          <p class="mt-2">{{issueDetail.description}}</p>
                        </div>
                        <div class="body-sec">
                          <div class="row h-100">
                            <div class="col l12 h-100">
                              <div class="activity-section">
                                <div class="activitylog-sec" v-for="(track,index) in issueDetail.activity_stream" :key="index">
                                  <div class="activity-pro-img">
                                    <img
                                      src="/assets/images/avatar/profile.svg"
                                      alt
                                    />
                                  </div>
                                  <div class="activity-desc">
                                    <p>
                                      {{track.actor}}
                                      <span
                                        class="activity-action"
                                      >{{track.verb}}</span>
                                    </p>
                                  </div>
                                  <div class="activity-date">
                                    <p>{{track.timestamp | date('MMM d, YYYY, h:mm a')}}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="assignees-list">
      <div class="input-search-box search-input">
        <div class="search-area">
          <i class="material-icons mr-2 search-icon">search</i>
          <input
            type="text"
            placeholder="Search assignees"
            id="assignee_filter"
            class="app-filter assignee_filter"
          />
        </div>
      </div>
      <div class="list-opts">
        <div
          class="assignees-list-items"
          @click="selectAssignee(assignee)"
          v-for="(assignee,index) in assigneeList"
          :key="index"
        >
          <div class="usr-img">{{assignee.short_name}}</div>
          <div class="uname">{{assignee.first_name}}</div>
          <div class="fullname">{{assignee.mobile_number}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoader: true,
      issueNo: this.$route.params.id,
      issueDetail: {},
      assigneeList: []
    };
  },
  created() {
    this.retrieveIssue();
    this.listAssignees();
    setTimeout(() => {
      $("html")
        .off("click")
        .on("click", function(e) {
          if (
            !$(e.target).hasClass("a-settings") &&
            !$(e.target).hasClass("assignee_filter")
          ) {
            $(".assignees-list").removeClass("show-assignee");
          }
        });
    }, 500);
  },
  methods: {
    retrieveIssue() {
      this.isLoader = true;
      ajax.get(
        Constants.default.APIURL.RetrieveTicket + this.issueNo,
        res => {
          this.issueDetail = res.data;
          this.isLoader = false;
        },
        err => {
          this.isLoader = false;
        }
      );
    },
    listAssignees(url = Constants.default.APIURL.SubAdmin) {
      let userDetails = JSON.parse(localStorage.homecare_admin_auth);
      return new Promise(resolve => {
        ajax.get(
          url,
          res => {
            let assignees = [
              {
                id: userDetails.id,
                first_name: "Assign Myself",
                short_name: "ME"
              }
            ];
            this.assigneeList = assignees.concat(res.data);
            resolve(true);
          },
          err => {
            resolve(false);
          }
        );
      });
    },
    selectAssignee(assignee) {
      let userDetails = JSON.parse(localStorage.homecare_admin_auth);
      let query = {
        user: assignee.id
      };
      ajax.patch(
        Constants.default.APIURL.IssueTickets +
          this.issueDetail.issue_no +
          "/assign/",
        query,
        async res => {
          Vue.toast("Ticket has been assigned successfully.");
          this.retrieveIssue();
        },
        err => {
          Vue.toast("", err);
        }
      );
    },
    assignMySelf() {
      this.selectAssignee({
        id: JSON.parse(localStorage.homecare_admin_auth).id
      });
    },
    openAssignees(ev) {
      var top = $(ev.target).offset().top + 30;
      var left = $(ev.target).offset().left - 300;
      $(".assignees-list").addClass("show-assignee");
      $(".assignees-list").css("top", top + "px");
      $(".assignees-list").css("left", left + "px");
    }
  }
};
</script>
<style <style lang="scss" scoped>
.card .card-title {
  font-size: 20px !important;
}
.header-sec {
  text-align: left;
  .details {
    font-size: 14px;
    .name {
      font-weight: 600;
      padding-right: 10px;
    }
    .divider-line {
      color: gainsboro;
      font-weight: 500;
      font-size: 18px;
      position: absolute;
    }
    .createdby {
      font-weight: 500;
      padding-right: 10px;
    }
    .classtag {
      font-size: 13px;
      margin-left: 15px;
    }
  }
  .label-status {
    display: inline-block;
    margin-bottom: 3px;
    margin-top: 10px;
    .cancel-bloc {
      float: right;
      margin-top: -10px;
    }

    span {
      font-weight: 600;
      padding: 2px 12px;
      border-radius: 5px;
      font-size: 13px;
      &.classtag {
        border-radius: 5px;
        border: 1px solid gainsboro;
        margin-right: 15px;
        color: #ef0000;
      }
      &.prioritytag {
        border: 1px solid gainsboro;
      }

      &.statustag {
        border: 1px solid gainsboro;
        margin-left: 15px;
        color: #4783c9;
      }
    }
  }
}
.body-sec {
  text-align: left;
  margin-top: 30px;
   .activity-section {
      background: #ffffff;
      border-radius: 4px;
      color: #183247;
      font-family: SFProText;
      overflow: auto;
      height: 100%;

      .activitylog-sec {
        position: relative;
        display: flex;
        align-items: center;
        min-height: 56px;
        margin-bottom: 15px;

        &:first-child::before {
          display: none;
        }

        &::before {
          content: '';
          width: 3px;
          height: 100%;
          background-color: #ebeff4;
          position: absolute;
          left: 1.4%;
          top: -60%;
        }

        .activity-pro-img {
          display: inline-block;
          margin-right: 15px;
          width: 4%;
          z-index: 1;

          img {
            width: 38px;
            height: 38px;
            border-radius: 50%;
            object-fit: cover;
            box-shadow: 0px 0px 0px 5px #ffffff;
          }
        }

        .activity-desc {
          display: inline-block;
          font-size: 14px;
          color: #183247;
          width: 76%;

          p {
            margin-bottom: 0px;

            span.activity-action {
              font-size: 15px;
              font-weight: 700;
            }
          }
        }

        .activity-date {
          display: inline-block;
          font-size: 12px;
          text-align: right;
          color: #183247;
          width: 20%;

          p {
            margin-bottom: 0px;
          }
        }
      }
    }
}

.bg-track-odd {
  background: rgb(245, 247, 249) !important;
}

.p0 {
  padding: 0 !important;
  padding-left: 0 !important;
}
a.booking {
  z-index: 999999;
  padding: 10px 5px;
  perspective: 1000px;
  font-size: 80% !important;
}
.assignee-block {
  position: relative;
  text-align: left;
  .assignee-title {
    font-weight: 500;
  }
  .assignee {
    color: #183247;
    font-size: 14px;
  }
  i {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;
    font-size: 18px;
    perspective-origin: 1000px;
    cursor: pointer;
  }
}

.assignees-list {
  border-radius: 3px;
  border: 1px solid gainsboro;
  padding: 0px;
  max-height: 0;
  transition: 0.3s ease-in-out;
  opacity: 0;
  min-width: 300px;
  z-index: 99999999;
  perspective: 1000px;
  position: absolute;
  overflow-y: auto;
  overflow-x: hidden;
  background: white;
  .list-opts {
    min-height: 100px;
    .loader {
      svg {
        width: 100px;
      }
    }
  }
  .input-search-box {
    padding: 10px;
    position: sticky;
    top: 0;
    background: white;
  }
  .assignees-list-items {
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: flex-start;
    padding: 5px 10px 0px 10px;
    border-bottom: 1px solid #f1eded;
    div {
      margin: 5px;
      padding: 0px;
    }
    .usr-img {
      width: 30px;
      height: 30px;
      border-radius: 5px;
      background: #efe7e7;
    }

    .uname {
      font-weight: 600;
    }
  }
}
.show-assignee {
  max-height: 300px;
  opacity: 1;
}

.search-input {
  .sidebar-search {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    padding: 1rem 0;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .search-area {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    width: -webkit-calc(100% - 0rem);
    width: -moz-calc(100% - 0rem);
    width: calc(100% - 0rem);
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  i {
    font-size: 1.45rem;
    height: 41px;
    margin-right: 0 !important;
    padding: 0.75rem 0.25rem 0.35rem 0.75rem;
    color: #9e9e9e;
    border-radius: 5px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    background-color: #eceff1;
  }
  .app-filter {
    height: 35px;
    margin-bottom: 0;
    padding: 0.2rem;
    color: #9e9e9e;
    border: none;
    border-radius: 5px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    background-color: #eceff1;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    border-bottom: 0 !important;
    box-shadow: none !important;
  }
}
</style>

